export const coreAddresses = {
  balanceTracker: "0xa231DccE58EA5A43E69EF351D89ea4212Ec0f30b",
  eVaultFactory: "0xba4Dd672062dE8FeeDb665DD4410658864483f1E",
  eVaultImplementation: "0xef17750D3a162E28a302E266c474ff8989d60ECD",
  eulerEarnFactory: "0xF463d4Acb650cc6C4E1D6cD4D0d1b0cb224094cF",
  evc: "0x7a9324E8f270413fa2E458f5831226d99C7477CD",
  permit2: "0x000000000022D473030F116dDEE9F6B43aC78BA3",
  protocolConfig: "0x94A2d1d175F1d828935a374091e2009CF1cED858",
  sequenceRegistry: "0x39F81037f20AC6068CbCd30f748094c58bfE7d7b",
} as const
